import _ from 'lodash'
import AuthApi from '@/store/api/system/auth'

// Whether a File is publicly reachable (its `url` is a real public URL) or private
// (must be streamed through the token-authenticated storage route).
export const isFilePublic = file => _.get(file, 'visibility') === 'public'

// The storage-route URL for a File: the public route for public files, or the
// private route with the caller's auth token appended for private ones.
export const storageFileUrl = file => {
    const fileId = _.get(file, 'id')
    const fileName = _.get(file, 'name')
    if (!fileId || !fileName) return ''

    const publicFile = isFilePublic(file)
    const route = _.trim(
        `${process.env.VUE_APP_API_ENDPOINT}${publicFile ? process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE : process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
        '/'
    )
    if (!route) return ''

    let url = `${route}/files/${fileId}/${encodeURIComponent(fileName)}`
    if (!publicFile) {
        const token = AuthApi.getToken()
        if (!token) return ''
        url += `?token=${encodeURIComponent(token)}`
    }

    return url
}

// A browser-displayable URL for a File: its public `url` for public files, else the
// token-authenticated storage route. Use this for <img>/<source> src — the raw
// `file.url` is empty/unreachable for private files.
export const fileAccessUrl = file => {
    if (!file) return ''

    const fileUrl = String(_.get(file, 'url', '') || '')
    const storageUrl = storageFileUrl(file)

    if (!isFilePublic(file)) return storageUrl || fileUrl

    return fileUrl || storageUrl
}
